import { postCoreDataDictionaryExportSlice } from './post';

export const { requestPostCoreDataDictionaryExport, resetPostCoreDataDictionaryExport } =
	postCoreDataDictionaryExportSlice.asyncActionCreators;
